import { colorMap, SentimentDistribution, sentimentLabels, SentimentType } from './model'
import React from 'react'
import { Circle } from './Circle'
import { roundDistributionTo100 } from './helper'

export type SentimentDistributionInfoProps = {
  distribution: SentimentDistribution
  useEmojis?: boolean
  ignoreZero?: boolean
}

export const SentimentDistributionInfo: React.FC<SentimentDistributionInfoProps> = ({ distribution, ignoreZero = false, useEmojis = false }) => {
  const keys = Object.keys(colorMap) as SentimentType[]
  const rounded = roundDistributionTo100(distribution)
  const LegendSymbol = ({ sentimentType, className, colorize }: { sentimentType: SentimentType; className?: string; colorize?: boolean }) => {
    if (useEmojis) {
      const emojiMap = {
        positive: 'emoji-smile',
        negative: 'emoji-frown',
        neutral: 'emoji-neutral',
      }

      const styles: { [key: string]: any } = {
        strokeWidth: '3px',
      }
      if (colorize) {
        styles['color'] = colorMap[sentimentType]
      }

      return <i style={styles} className={`bi bi-${emojiMap[sentimentType]}${className ? ' ' + className : ''}`} />
    }
    return <Circle fill={colorMap[sentimentType]} />
  }

  return (
    <>
      {keys
        .filter((key) => !(ignoreZero && rounded[key] === 0))
        .map((key) => (
          <div className='sentiment-distribution-container d-flex gap-2 flex-row align-items-center' key={key}>
            <div className='sentiment-symbol'>
              <LegendSymbol sentimentType={key} className={`sentiment-legend-symbol sentiment-legend-symbol-${key}`} colorize={true} />{' '}
            </div>
            <div className='sentiment-distribution-text'>
              <div>
                <strong>{rounded[key]}%</strong>
              </div>
              <div className='text-secondary'>{sentimentLabels[key]}</div>
            </div>
          </div>
        ))}
    </>
  )
}
